import React from "react";
import { useQuery } from "@tanstack/react-query";
import { Mail } from "lucide-react";
import { adminGetContact } from "@/lib/api";
import { AdminShell } from "@/components/admin/AdminShell";

export default function AdminMessages() {
  const { data: messages = [], isLoading } = useQuery({ queryKey: ["admin-contact"], queryFn: adminGetContact });
  return (
    <AdminShell title="Messages">
      {isLoading ? (
        <div className="h-64 animate-pulse rounded-[14px] border" style={{ background: "var(--surface)", borderColor: "var(--card-border)" }} />
      ) : messages.length === 0 ? (
        <div className="flex flex-col items-center justify-center rounded-[14px] border border-dashed py-20" style={{ borderColor: "var(--card-border)" }}>
          <Mail size={26} style={{ color: "var(--muted)" }} />
          <p className="mt-3 text-sm" style={{ color: "var(--text)" }}>No enquiries yet.</p>
        </div>
      ) : (
        <div className="space-y-3">
          {messages.map((m) => (
            <div key={m.id} className="rounded-[14px] border p-5" style={{ background: "var(--surface)", borderColor: "var(--card-border)" }}>
              <div className="flex flex-wrap items-center justify-between gap-2">
                <div>
                  <p className="text-sm font-medium" style={{ color: "var(--text)" }}>{m.name} <span className="font-normal" style={{ color: "var(--muted)" }}>&lt;{m.email}&gt;</span></p>
                  <p className="text-xs" style={{ color: "var(--muted)" }}>{m.category}{m.organisation ? ` • ${m.organisation}` : ""}</p>
                </div>
                <span className="text-xs" style={{ color: "var(--fg-subtle)" }}>{new Date(m.createdAt).toLocaleString()}</span>
              </div>
              <p className="mt-3 whitespace-pre-wrap text-sm leading-relaxed" style={{ color: "var(--muted)" }}>{m.message}</p>
            </div>
          ))}
        </div>
      )}
    </AdminShell>
  );
}
